import { FormSection } from '../CastingProfile.styles';
import MetadataChipGroup from './MetadataChipGroup';

type AttractivenessFieldProps = {
  options: Array<{ value: string; display: string }>;
  selected: string[];
  onChange: (selected: string[]) => void;
  error?: string;
};

const AttractivenessField = (props: AttractivenessFieldProps) => (
  <FormSection>
    <MetadataChipGroup label="On-brand attractiveness" {...props} />
  </FormSection>
);

export default AttractivenessField;
